import { render, staticRenderFns } from "./colors.vue?vue&type=template&id=3d4b6b38&scoped=true"
import script from "./colors.vue?vue&type=script&lang=js"
export * from "./colors.vue?vue&type=script&lang=js"
import style0 from "./colors.vue?vue&type=style&index=0&id=3d4b6b38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b6b38",
  null
  
)

export default component.exports